/* Structured Space — homepage planner recommendation quiz (vanilla JS) */
(function () {
  'use strict';

  var INIT_ATTR = 'data-ss-planner-quiz-init';
  var SCORE_KEYS = ['adhd', 'calmly', 'clearDays', 'simple'];

  var DEFAULT_QUESTIONS = [
    {
      text: 'What feels hardest lately?',
      answers: [
        { label: 'Keeping on top of life admin', scores: { adhd: 3, calmly: 0, clearDays: 0, simple: 0 } },
        { label: 'Cleaning feels impossible', scores: { adhd: 0, calmly: 3, clearDays: 0, simple: 0 } },
        { label: 'Brain fog / health', scores: { adhd: 0, calmly: 0, clearDays: 3, simple: 0 } },
        { label: 'I just want something simple', scores: { adhd: 0, calmly: 0, clearDays: 0, simple: 3 } }
      ]
    },
    {
      text: 'What would help most?',
      answers: [
        { label: 'One place for bills tasks and appointments', scores: { adhd: 3, calmly: 0, clearDays: 0, simple: 0 } },
        { label: 'One manageable cleaning task at a time', scores: { adhd: 0, calmly: 3, clearDays: 0, simple: 0 } },
        { label: 'Planning around energy and focus', scores: { adhd: 0, calmly: 0, clearDays: 3, simple: 0 } },
        { label: 'One simple focused tool', scores: { adhd: 0, calmly: 0, clearDays: 0, simple: 3 } }
      ]
    },
    {
      text: 'How much structure do you like?',
      answers: [
        {
          label: 'A full dashboard I can grow into',
          scores: { adhd: 2, calmly: 1, clearDays: 1, simple: 0 }
        },
        { label: 'Gentle routines and reminders', scores: { adhd: 1, calmly: 2, clearDays: 0, simple: 0 } },
        { label: 'Flexible day-by-day planning', scores: { adhd: 0, calmly: 0, clearDays: 2, simple: 0 } },
        { label: 'As little structure as possible', scores: { adhd: 0, calmly: 0, clearDays: 0, simple: 3 } }
      ]
    }
  ];

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function parseConfig(root) {
    var node = qs('[data-ss-planner-quiz-config]', root);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function emptyScores() {
    return { adhd: 0, calmly: 0, clearDays: 0, simple: 0 };
  }

  function cloneScores(scores) {
    var out = emptyScores();
    SCORE_KEYS.forEach(function (key) {
      out[key] = scores[key] || 0;
    });
    return out;
  }

  function addScores(target, add) {
    SCORE_KEYS.forEach(function (key) {
      target[key] += add[key] || 0;
    });
  }

  function subtractScores(target, sub) {
    SCORE_KEYS.forEach(function (key) {
      target[key] -= sub[key] || 0;
    });
  }

  function normalizeAnswerScores(raw) {
    var scores = emptyScores();
    if (!raw) return scores;
    SCORE_KEYS.forEach(function (key) {
      scores[key] = Number(raw[key]) || 0;
    });
    return scores;
  }

  function normalizeQuestions(configQuestions) {
    if (!Array.isArray(configQuestions) || !configQuestions.length) {
      return DEFAULT_QUESTIONS;
    }

    return configQuestions.map(function (question) {
      return {
        text: question.text || question.question || '',
        answers: (question.answers || []).map(function (answer) {
          return {
            label: answer.label || answer.title || '',
            text: answer.text || answer.note || '',
            scores: normalizeAnswerScores(answer.scores || answer.w)
          };
        })
      };
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatProgress(template, current, total) {
    var fmt = template || 'Question {current} of {total}';
    return fmt
      .replace(/\{\{\s*current\s*\}\}/g, String(current))
      .replace(/\{\{\s*total\s*\}\}/g, String(total))
      .replace(/\{current\}/g, String(current))
      .replace(/\{total\}/g, String(total));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToDemo(plannerId, config, winnerKey) {
    var demoPageUrl = '';
    if (config && config.results && winnerKey && config.results[winnerKey]) {
      demoPageUrl = config.results[winnerKey].demoPageUrl || '';
    }
    if (demoPageUrl) {
      window.location.assign(demoPageUrl);
      return;
    }
    var hub = document.getElementById('try-the-planners') || document.getElementById('ss-demo');
    if (hub) {
      hub.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
    }
    if (plannerId) {
      document.dispatchEvent(
        new CustomEvent('ss:select-demo-planner', {
          detail: { planner: plannerId }
        })
      );
    }
  }

  function computeWinner(scores, q1Scores) {
    var max = Math.max(scores.adhd, scores.calmly, scores.clearDays, scores.simple);
    var tied = SCORE_KEYS.filter(function (key) {
      return scores[key] === max;
    });

    if (tied.length === 1) {
      return tied[0];
    }

    var q1max = Math.max.apply(
      null,
      tied.map(function (key) {
        return q1Scores[key] || 0;
      })
    );
    var q1winners = tied.filter(function (key) {
      return (q1Scores[key] || 0) === q1max;
    });

    return q1winners[0] || tied[0];
  }

  function PlannerQuiz(root, config) {
    this.root = root;
    this.config = config;
    this.questions = normalizeQuestions(config.questions);
    this.total = this.questions.length;
    this.current = 0;
    this.answers = [];
    this.answerScores = [];
    this.scores = emptyScores();
    this.q1Scores = emptyScores();
    this.transitionMs = prefersReducedMotion() ? 0 : 220;

    this.interactive = qs('[data-ss-planner-quiz-interactive]', root);
    this.questionsPanel = qs('[data-ss-planner-quiz-questions]', root);
    this.resultPanel = qs('[data-ss-planner-quiz-result]', root);
    this.questionMount = qs('[data-ss-planner-quiz-question-mount]', root);
    this.resultMount = qs('[data-ss-planner-quiz-result-mount]', root);
    this.progressText = qs('[data-ss-planner-quiz-progress-text]', root);
    this.progressBar = qs('[data-ss-planner-quiz-progress-bar]', root);
    this.progressFill = qs('[data-ss-planner-quiz-progress-fill]', root);
    this.backBtn = qs('[data-ss-planner-quiz-back]', root);
    this.restartBtn = qs('[data-ss-planner-quiz-restart]', root);
    this.liveRegion = qs('[data-ss-planner-quiz-live]', root);
    this.resultLive = qs('[data-ss-planner-quiz-result-live]', root);

    this.bind();
    if (this.interactive) this.interactive.hidden = false;
    this.renderQuestion(true);
  }

  PlannerQuiz.prototype.bind = function () {
    var self = this;
    if (this.backBtn) {
      this.backBtn.addEventListener('click', function (event) {
        event.preventDefault();
        self.goBack();
      });
    }
    if (this.restartBtn) {
      this.restartBtn.addEventListener('click', function (event) {
        event.preventDefault();
        self.restart();
      });
    }
  };

  PlannerQuiz.prototype.announce = function (node, text) {
    if (node) node.textContent = text;
  };

  PlannerQuiz.prototype.updateProgress = function () {
    var current = this.current + 1;
    if (this.progressText) {
      this.progressText.textContent = formatProgress(
        this.config.progressFormat,
        current,
        this.total
      );
    }
    if (this.progressBar) {
      this.progressBar.setAttribute('aria-valuemin', '1');
      this.progressBar.setAttribute('aria-valuemax', String(this.total));
      this.progressBar.setAttribute('aria-valuenow', String(current));
    }
    if (this.progressFill) {
      this.progressFill.style.width = String((current / this.total) * 100) + '%';
    }
    if (this.backBtn) {
      this.backBtn.hidden = this.current === 0;
    }
  };

  PlannerQuiz.prototype.setPanelVisible = function (panel, visible) {
    if (!panel) return;
    panel.hidden = !visible;
    panel.classList.toggle('is-active', visible);
    if (visible) {
      panel.classList.remove('is-leaving');
    }
  };

  PlannerQuiz.prototype.renderQuestion = function (initial) {
    var question = this.questions[this.current];
    if (!question || !this.questionMount) return;

    this.updateProgress();
    this.setPanelVisible(this.questionsPanel, true);
    this.setPanelVisible(this.resultPanel, false);

    var sectionId = this.config.sectionId || 'quiz';
    var html =
      '<h3 class="ss-planner-quiz__question" tabindex="-1" id="ss-planner-quiz-q-' +
      escapeHtml(sectionId) +
      '-' +
      this.current +
      '">' +
      escapeHtml(question.text) +
      '</h3><ul class="ss-planner-quiz__answers" role="list">';

    question.answers.forEach(function (answer, index) {
      html +=
        '<li><button type="button" class="ss-planner-quiz__answer" data-answer-index="' +
        index +
        '"><span class="ss-planner-quiz__answer-label">' +
        escapeHtml(answer.label) +
        '</span>';
      if (answer.text) {
        html +=
          '<span class="ss-planner-quiz__answer-text">' + escapeHtml(answer.text) + '</span>';
      }
      html += '</button></li>';
    });
    html += '</ul>';

    this.questionMount.innerHTML = html;
    this.announce(
      this.liveRegion,
      'Question ' + (this.current + 1) + ' of ' + this.total + '. ' + question.text
    );

    var selected = this.answers[this.current];
    var self = this;
    qsa('[data-answer-index]', this.questionMount).forEach(function (btn) {
      var index = parseInt(btn.getAttribute('data-answer-index'), 10);
      if (selected === index) btn.classList.add('is-selected');
      btn.addEventListener('click', function () {
        self.selectAnswer(index);
      });
    });

    if (!initial) {
      var heading = qs('.ss-planner-quiz__question', this.questionMount);
      if (heading) heading.focus({ preventScroll: true });
    } else {
      var firstAnswer = qs('.ss-planner-quiz__answer', this.questionMount);
      if (firstAnswer) firstAnswer.focus({ preventScroll: true });
    }
  };

  PlannerQuiz.prototype.selectAnswer = function (answerIndex) {
    var question = this.questions[this.current];
    if (!question || !question.answers[answerIndex]) return;

    var prevIndex = this.answers[this.current];
    if (prevIndex !== undefined && prevIndex !== null) {
      subtractScores(this.scores, this.answerScores[this.current]);
      if (this.current === 0) {
        this.q1Scores = emptyScores();
      }
    }

    var contribution = cloneScores(question.answers[answerIndex].scores);
    this.answers[this.current] = answerIndex;
    this.answerScores[this.current] = contribution;
    addScores(this.scores, contribution);

    if (this.current === 0) {
      this.q1Scores = cloneScores(contribution);
    }

    qsa('.ss-planner-quiz__answer', this.questionMount).forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    var selectedBtn = qs('[data-answer-index="' + answerIndex + '"]', this.questionMount);
    if (selectedBtn) selectedBtn.classList.add('is-selected');

    var self = this;
    window.setTimeout(function () {
      if (self.current < self.total - 1) {
        self.current += 1;
        self.renderQuestion(false);
      } else {
        self.showResult();
      }
    }, this.transitionMs);
  };

  PlannerQuiz.prototype.goBack = function () {
    if (this.current === 0) return;
    this.current -= 1;
    this.renderQuestion(false);
  };

  PlannerQuiz.prototype.getResult = function (key) {
    var results = this.config.results || {};
    return results[key] || null;
  };

  PlannerQuiz.prototype.buildResultHtml = function (winnerKey) {
    var result = this.getResult(winnerKey);
    if (!result) return '';

    var matchHeading = this.config.matchHeading || 'Your best match';
    var browseAllUrl = this.config.browseAllUrl || '/collections/all';
    var browseAllLabel = this.config.browseAllLabel || 'Browse all planners';
    var demoBlock = '';

    if (winnerKey === 'calmly' && this.config.calmlyDemoAvailable === false) {
      demoBlock =
        '<p class="ss-planner-quiz__demo-soon">' +
        escapeHtml(
          this.config.calmlyDemoSoon ||
            'Preview available — interactive demo coming soon.'
        ) +
        '</p>';
    } else if (result.demoId) {
      demoBlock =
        '<button type="button" class="ss-planner-quiz__cta ss-planner-quiz__cta--secondary" data-ss-planner-quiz-demo="' +
        escapeHtml(result.demoId) +
        '">' +
        escapeHtml(result.secondaryLabel || 'Try Demo') +
        '</button>';
    }

    var imageBlock = '';
    if (result.imageUrl) {
      imageBlock =
        '<div class="ss-planner-quiz__result-media"><img src="' +
        escapeHtml(result.imageUrl) +
        '" alt="' +
        escapeHtml(result.imageAlt || result.name || matchHeading) +
        '" width="900" height="600" loading="lazy" decoding="async"></div>';
    }

    var simpleNote = '';
    if (winnerKey === 'simple') {
      var essentialsUrl = this.config.essentialsUrl || '/collections/essentials';
      var essentialsLabel =
        this.config.essentialsLabel || 'Browse our smaller planners';
      var simpleLead =
        this.config.simpleNoteLead || 'Looking for something lighter?';
      simpleNote =
        '<p class="ss-planner-quiz__lighter-note">' +
        escapeHtml(simpleLead) +
        ' <a href="' +
        escapeHtml(essentialsUrl) +
        '">' +
        escapeHtml(essentialsLabel) +
        '</a>.</p>';
    }

    return (
      '<div class="ss-planner-quiz__result-card">' +
      '<p class="ss-planner-quiz__result-eyebrow">' +
      escapeHtml(matchHeading) +
      '</p>' +
      '<div class="ss-planner-quiz__result-layout' +
      (result.imageUrl ? ' has-image' : '') +
      '">' +
      imageBlock +
      '<div class="ss-planner-quiz__result-copy">' +
      '<h3 class="ss-planner-quiz__result-heading" tabindex="-1">' +
      escapeHtml(result.heading || result.name || matchHeading) +
      '</h3>' +
      '<p class="ss-planner-quiz__result-body">' +
      escapeHtml(result.body || '') +
      '</p>' +
      '<div class="ss-planner-quiz__result-ctas">' +
      '<a class="ss-planner-quiz__cta ss-planner-quiz__cta--primary" href="' +
      escapeHtml(result.productUrl || '#') +
      '">' +
      escapeHtml(result.primaryLabel || 'View Planner') +
      '</a>' +
      demoBlock +
      '</div>' +
      (result.note
        ? '<p class="ss-planner-quiz__result-note">' + escapeHtml(result.note) + '</p>'
        : '') +
      simpleNote +
      '<p class="ss-planner-quiz__browse-all"><a href="' +
      escapeHtml(browseAllUrl) +
      '">' +
      escapeHtml(browseAllLabel) +
      '</a></p>' +
      '</div></div></div>'
    );
  };

  PlannerQuiz.prototype.showResult = function () {
    if (this.questionsPanel) {
      this.questionsPanel.classList.add('is-leaving');
    }

    var self = this;
    window.setTimeout(function () {
      var winnerKey = computeWinner(self.scores, self.q1Scores);
      var html = self.buildResultHtml(winnerKey);

      self.setPanelVisible(self.questionsPanel, false);
      self.setPanelVisible(self.resultPanel, true);

      if (self.resultMount) self.resultMount.innerHTML = html;

      var result = self.getResult(winnerKey);
      self.announce(
        self.resultLive,
        (self.config.matchHeading || 'Your best match') +
          '. ' +
          (result && (result.heading || result.name) ? result.heading || result.name : '')
      );

      var heading = qs('.ss-planner-quiz__result-heading', self.resultMount);
      if (heading) heading.focus({ preventScroll: true });

      qsa('[data-ss-planner-quiz-demo]', self.resultMount).forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToDemo(btn.getAttribute('data-ss-planner-quiz-demo'), self.config, winnerKey);
        });
      });
    }, this.transitionMs);
  };

  PlannerQuiz.prototype.restart = function () {
    this.current = 0;
    this.answers = [];
    this.answerScores = [];
    this.scores = emptyScores();
    this.q1Scores = emptyScores();
    if (this.resultMount) this.resultMount.innerHTML = '';
    this.renderQuestion(false);
  };

  function initRoot(root) {
    if (!root || root.getAttribute(INIT_ATTR) === 'true') return;

    var config = parseConfig(root);
    if (!config) return;

    root.setAttribute(INIT_ATTR, 'true');
    new PlannerQuiz(root, config);
  }

  function initAll(scope) {
    qsa('[data-ss-planner-quiz-root]', scope || document).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!section) return;
    var root = qs('[data-ss-planner-quiz-root]', section);
    if (!root) return;
    root.removeAttribute(INIT_ATTR);
    initRoot(root);
  });
})();
